import { render } from "./ManagementPageWithActions.vue?vue&type=template&id=1ff3be07&scoped=true&lang=pug"
import script from "./ManagementPageWithActions.vue?vue&type=script&lang=js"
export * from "./ManagementPageWithActions.vue?vue&type=script&lang=js"

import "./ManagementPageWithActions.vue?vue&type=style&index=0&id=1ff3be07&lang=scss"
import "./ManagementPageWithActions.vue?vue&type=style&index=1&id=1ff3be07&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff3be07"]])

export default __exports__